import React from 'react';
import {
    Grid,
    Typography,
    TextField,
    Button,
    Dialog,
    DialogContent,
    MenuItem,
} from '@mui/material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import AppDialogTitle from '../../../../ui/appDialogTitle';
import { isLocalDev } from '../../../../../utils/environment';
import { ContactLensConfigurationService } from '../../../../../service/validDataService';
import validLookup from '../../../../../utils/validLookup';

export const initialValuesScheduleForm = {
    name: '',
    daysSupply: 1,
    status: validLookup.validStatus.active,
    notes: '',
};

const validationSchema = Yup.object({
    name: Yup.string().required('Schedule name is required'),
    daysSupply: Yup.number()
        .positive('Days supply must be positive')
        .integer('Days supply must be a whole number')
        .required('Days supply is required'),
});

export default function ContactLensScheduleInputForm({ open, onClose, onRecordAdded }) {

    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        try {
            const response = await ContactLensConfigurationService.addSchedule(values);
            const { code, data, message } = response;

            setSubmitting(false);

            if (code === 0) {
                toast.success(message);
                resetForm();
                onRecordAdded(data);
                onClose();
            } else {
                toast.error(message);
            }
        } catch (error) {
            if (isLocalDev) {
                console.error(error);
            }
            setSubmitting(false);
            toast.error('Failed to add contact lens schedule');
        }
    };

    return (
        <Dialog open={open} maxWidth={'sm'} fullWidth>
            <AppDialogTitle title={"Add Contact Lens Schedule"} onClose={onClose} />
            <DialogContent sx={{ mt: 1, mb: 1 }}>
                <Formik
                    initialValues={initialValuesScheduleForm}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="name"
                                        label="Schedule Name"
                                        required
                                        fullWidth
                                        size="small"
                                        helperText="e.g., Daily, Biweekly, Monthly, Yearly, or custom schedule name"
                                    />
                                    <ErrorMessage name="name">{message => <Typography color={'error'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="daysSupply"
                                        label="Days Supply"
                                        type="number"
                                        required
                                        fullWidth
                                        size="small"
                                        helperText="Number of days this schedule covers (1 for daily, 14 for biweekly, 30 for monthly, 365 for yearly)"
                                    />
                                    <ErrorMessage name="daysSupply">{message => <Typography color={'error'}>{message}</Typography>}</ErrorMessage>
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name='status'
                                        label="Status"
                                        fullWidth
                                        select
                                        size="small"
                                    >
                                        <MenuItem value={"active"}>Active</MenuItem>
                                        <MenuItem value={"inactive"}>Inactive</MenuItem>
                                    </Field>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        name="notes"
                                        label="Notes"
                                        multiline
                                        rows={3}
                                        fullWidth
                                        size="small"
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Adding...' : 'Add Schedule'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
}
